export const CENTRAL_VEHICLE_TYPES = [
  'convertible',
  'box-truck',
  'sedan',
  'suv',
  'hatchback',
] as const;

export type CentralVehicleType = (typeof CENTRAL_VEHICLE_TYPES)[number];

const VEHICLE_ASSET_URLS: Readonly<Record<CentralVehicleType, string>> = {
  convertible: '/assets/vehicles/convertible.png',
  'box-truck': '/assets/vehicles/box-truck.png',
  sedan: '/assets/vehicles/sedan-v2.png',
  suv: '/assets/vehicles/suv.png',
  hatchback: '/assets/vehicles/hatchback.png',
};

const imageCache = new Map<CentralVehicleType, HTMLImageElement>();

export function vehicleAssetUrl(type: CentralVehicleType): string {
  return VEHICLE_ASSET_URLS[type];
}

export function getVehicleImage(type: CentralVehicleType): HTMLImageElement | undefined {
  if (typeof Image === 'undefined') return undefined;
  const cached = imageCache.get(type);
  if (cached) return cached;
  const image = new Image();
  image.decoding = 'async';
  image.src = vehicleAssetUrl(type);
  imageCache.set(type, image);
  return image;
}

export function preloadVehicleImages(): void {
  for (const type of CENTRAL_VEHICLE_TYPES) getVehicleImage(type);
}

preloadVehicleImages();
